import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addControlRequest = {};
var _addControlResponse = {};
var _deleteControlRequest = {};
var _deleteControlResponse = {};
var _discardDraftRequest = {};
var _discardDraftResponse = {};
var _getFormRequest = {};
var _getFormResponse = {};
var _publishDraftRequest = {};
var _publishDraftResponse = {};
var _updateControlRequest = {};
var _updateControlResponse = {};
var _updateMessagesRequest = { fields: 'google.protobuf.FieldMask' };
var _updateMessagesResponse = {};
function resolveWixEventsFormFormBuilderUrl(opts) {
    var domainToMappings = {
        'events._base_domain_': [
            {
                srcPath: '',
                destPath: '',
            },
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
        ],
        'www.wixevents.com': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/api',
                destPath: '/api',
            },
            {
                srcPath: '/viewEvent',
                destPath: '/viewEvent',
            },
            {
                srcPath: '/viewRsvpDashboard',
                destPath: '/viewRsvpDashboard',
            },
            {
                srcPath: '/viewOrderDashboard',
                destPath: '/viewOrderDashboard',
            },
            {
                srcPath: '/viewSummarySubscription',
                destPath: '/viewSummarySubscription',
            },
            {
                srcPath: '/check-in',
                destPath: '/check-in',
            },
            {
                srcPath: '/oc',
                destPath: '/oc',
            },
            {
                srcPath: '/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/export',
                destPath: '/export',
            },
            {
                srcPath: '/tickets',
                destPath: '/tickets',
            },
            {
                srcPath: '/payment-redirect',
                destPath: '/payment-redirect',
            },
            {
                srcPath: '/admin',
                destPath: '/admin',
            },
            {
                srcPath: '/ticket',
                destPath: '/ticket',
            },
            {
                srcPath: '/media',
                destPath: '/media',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/wix-events-web',
                destPath: '',
            },
        ],
        'events.wixapps.net': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/events',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        'api._base_domain_': [
            {
                srcPath: '/events/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/events/v2',
                destPath: '/v2',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/events',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        _: [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/_api/wix-events-web/v2',
                destPath: '/v2',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/_api/wix-events-web/v2',
                destPath: '/v2',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/wix-events-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/wix-events-web/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v2/events',
                destPath: '/v2/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk/events',
                destPath: '/v1/bulk/events',
            },
            {
                srcPath: '/_api/wix-events-web/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/_api/wix-events-web/v1/tickets',
                destPath: '/v1/tickets',
            },
            {
                srcPath: '/events/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/events/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/events/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/events/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
            {
                srcPath: '/events/v1/bulk/events',
                destPath: '/v1/bulk/events',
            },
            {
                srcPath: '/events/v1/notifications',
                destPath: '/v1/notifications',
            },
            {
                srcPath: '/events/v1/reports',
                destPath: '/v1/reports',
            },
            {
                srcPath: '/events/v1/tickets',
                destPath: '/v1/tickets',
            },
            {
                srcPath: '/events/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/events/v1/site',
                destPath: '/v1/site',
            },
            {
                srcPath: '/events/v1/web',
                destPath: '/v1/web',
            },
            {
                srcPath: '/events/v2/tickets',
                destPath: '/v2/tickets',
            },
            {
                srcPath: '/events/v2/events',
                destPath: '/v2/events',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/events/v1/events',
                destPath: '/v1/events',
            },
            {
                srcPath: '/events/v1/tickets',
                destPath: '/v1/tickets',
            },
            {
                srcPath: '/events/v1/categories',
                destPath: '/v1/categories',
            },
            {
                srcPath: '/events/v1/orders',
                destPath: '/v1/orders',
            },
            {
                srcPath: '/events/v1/bulk/categories',
                destPath: '/v1/bulk/categories',
            },
            {
                srcPath: '/events/v2/events',
                destPath: '/v2/events',
            },
            {
                srcPath: '/events/v1/bulk-async/categories',
                destPath: '/v1/bulk-async/categories',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/wix-events-web/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/events/v2/events',
                destPath: '/v2/events',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves an event registration form (both the draft and published versions). */
export function getForm(payload) {
    var _a = serializer(_getFormRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getFormResponse, {}).fromJSON;
    function __getForm(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.form',
            method: 'GET',
            methodFqn: 'wix.events.form.FormBuilder.GetForm',
            url: resolveWixEventsFormFormBuilderUrl({
                protoPath: '/v1/events/{eventId}/form',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getForm.fromReq = fromReq;
    __getForm.__isAmbassador = true;
    return __getForm;
}
/** Adds an input control to the draft form. */
export function addControl(payload) {
    var _a = serializer(_addControlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addControlResponse, {}).fromJSON;
    function __addControl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.form',
            method: 'POST',
            methodFqn: 'wix.events.form.FormBuilder.AddControl',
            url: resolveWixEventsFormFormBuilderUrl({
                protoPath: '/v1/events/{eventId}/form/control',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addControl.fromReq = fromReq;
    __addControl.__isAmbassador = true;
    return __addControl;
}
/** Updates an existing input control in the draft form. */
export function updateControl(payload) {
    var _a = serializer(_updateControlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateControlResponse, {}).fromJSON;
    function __updateControl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.form',
            method: 'PUT',
            methodFqn: 'wix.events.form.FormBuilder.UpdateControl',
            url: resolveWixEventsFormFormBuilderUrl({
                protoPath: '/v1/events/{eventId}/form/controls/{id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateControl.fromReq = fromReq;
    __updateControl.__isAmbassador = true;
    return __updateControl;
}
/** Deletes an input control from the draft form. */
export function deleteControl(payload) {
    var _a = serializer(_deleteControlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteControlResponse, {}).fromJSON;
    function __deleteControl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.form',
            method: 'DELETE',
            methodFqn: 'wix.events.form.FormBuilder.DeleteControl',
            url: resolveWixEventsFormFormBuilderUrl({
                protoPath: '/v1/events/{eventId}/form/controls/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteControl.fromReq = fromReq;
    __deleteControl.__isAmbassador = true;
    return __deleteControl;
}
/**
 * Updates draft form messages, as displayed in the Wix UI before, during, and after the registration flow.
 * Configurable messages include form titles, response labels, "thank you" messages, and call-to-action texts.
 */
export function updateMessages(payload) {
    var _a = serializer(_updateMessagesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateMessagesResponse, {}).fromJSON;
    function __updateMessages(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.form',
            method: 'PATCH',
            methodFqn: 'wix.events.form.FormBuilder.UpdateMessages',
            url: resolveWixEventsFormFormBuilderUrl({
                protoPath: '/v1/events/{eventId}/form/messages',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateMessages.fromReq = fromReq;
    __updateMessages.__isAmbassador = true;
    return __updateMessages;
}
/**
 * Publishes the draft form.
 * Sets event registration form equal to contents of draft form.
 */
export function publishDraft(payload) {
    var _a = serializer(_publishDraftRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_publishDraftResponse, {}).fromJSON;
    function __publishDraft(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.form',
            method: 'POST',
            methodFqn: 'wix.events.form.FormBuilder.PublishDraft',
            url: resolveWixEventsFormFormBuilderUrl({
                protoPath: '/v1/events/{eventId}/form/publish',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __publishDraft.fromReq = fromReq;
    __publishDraft.__isAmbassador = true;
    return __publishDraft;
}
/**
 * Clears all changes to the draft form.
 * (Does not affect the published form.)
 */
export function discardDraft(payload) {
    var _a = serializer(_discardDraftRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_discardDraftResponse, {}).fromJSON;
    function __discardDraft(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v1.form',
            method: 'DELETE',
            methodFqn: 'wix.events.form.FormBuilder.DiscardDraft',
            url: resolveWixEventsFormFormBuilderUrl({
                protoPath: '/v1/events/{eventId}/form',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __discardDraft.fromReq = fromReq;
    __discardDraft.__isAmbassador = true;
    return __discardDraft;
}
//# sourceMappingURL=http.impl.js.map